import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiasEnCargaDescarga as Comp } from "app/features/componentes/cargas";

export interface Props {
    idCargaDescargaEAD: number;
}

/**Toma el idCargaDescarga y muestra las guias incluidas */
export class GuiasEnCargaDescarga extends React.PureComponent<Props> {
    idCargaDescarga = (props: Props) => props.idCargaDescargaEAD;
    guias = createSelectorRx(this.idCargaDescarga, idCargaDescarga => observeResource(resources.CargaDescargaEAD.ObtenerGuiasEnCargaDescarga, idCargaDescarga));

    onQuitarGuia = async (x: models.GuiaDTO) => {
        const idCarga = this.props.idCargaDescargaEAD;
        await resources.CargaDescargaEAD.QuitarGuia(idCarga, x.IdRegistro);
    }

    render() {
        const guias = this.guias(this.props);
        return <Comp value={guias} onQuitarGuia={this.onQuitarGuia} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/edit/estatus/items/guias.tsx